/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type {
  GnosisWrapper,
  GnosisWrapperInterface,
} from "../../contracts/GnosisWrapper";

const _abi = [
  {
    inputs: [],
    name: "NotAuthorized",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "contract IDAOAccessControl",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gnosisSafe",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_accessControl",
        type: "address",
      },
      {
        internalType: "address",
        name: "_gnosisSafe",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "moduleFactory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
];

const _bytecode =
  "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";

type GnosisWrapperConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GnosisWrapperConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GnosisWrapper__factory extends ContractFactory {
  constructor(...args: GnosisWrapperConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<GnosisWrapper> {
    return super.deploy(overrides || {}) as Promise<GnosisWrapper>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): GnosisWrapper {
    return super.attach(address) as GnosisWrapper;
  }
  override connect(signer: Signer): GnosisWrapper__factory {
    return super.connect(signer) as GnosisWrapper__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GnosisWrapperInterface {
    return new utils.Interface(_abi) as GnosisWrapperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GnosisWrapper {
    return new Contract(address, _abi, signerOrProvider) as GnosisWrapper;
  }
}
